import { FC, useCallback } from "react";
import { PopoverOrigin, Stack, Typography } from "@mui/material";
import { CommitmentsUtilizationGrouping } from "@/services/cloudchipr.api";
import { InfoDataChip } from "@/components/pages/dashboard/components/widgets/common/widget-header/source-and-name/InfoDataChip";
import { commitmentGroupByTitleByGrouping } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/commitment-utilization/utils/constants/constants";
import { CommitmentUtilizationWidgetGroupBySelect } from "@/components/pages/dashboard/components/widgets/commitment-utlization/components/CommitmentUtilizationWidgetGroupBySelect";
import { WidgetQuickActionTrigger } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/common/WidgetQuickActionTrigger";
import { updateCommitmentUtilizationWidgetFromQuickActionsThunk } from "@/store/dashboards/thunks/widgets/commitment-utilization/actions/updateCommitmentUtilizationWidgetFromQuickActionsThunk";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { useAppAbility } from "@/services/permissions";
import { currentDashboardProtectedSelector } from "@/store/dashboards/selectors/dashboard-hierarchy-visibility/currentDashboardProtectedSelector";

interface CommitmentUtilizationWidgetHeaderGroupBySelectProps {
  widgetId?: string;
  grouping: CommitmentsUtilizationGrouping;
}

export const CommitmentUtilizationWidgetHeaderGroupBySelect: FC<
  CommitmentUtilizationWidgetHeaderGroupBySelectProps
> = ({ widgetId, grouping }) => {
  const dispatch = useAppDispatch();

  const { cannot } = useAppAbility();
  const canNotEditWidget = cannot("edit", "dashboard");
  const isProtected = useAppSelector(currentDashboardProtectedSelector);

  const handleChange = useCallback(
    (grouping: CommitmentsUtilizationGrouping) => {
      dispatch(
        updateCommitmentUtilizationWidgetFromQuickActionsThunk({
          id: widgetId,
          grouping,
        }),
      );
    },
    [dispatch, widgetId],
  );

  return (
    <InfoDataChip>
      <Stack spacing={0.5} direction="row" alignItems="center">
        <Typography variant="inherit">Group By:</Typography>
        <Typography
          component="span"
          variant="inherit"
          fontWeight="medium"
          color="text.primary"
        >
          {commitmentGroupByTitleByGrouping.get(grouping)}
        </Typography>
        {!canNotEditWidget && !isProtected && (
          <CommitmentUtilizationWidgetGroupBySelect
            onChange={handleChange}
            grouping={grouping}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
            CustomTriggerComponent={WidgetQuickActionTrigger}
          />
        )}
      </Stack>
    </InfoDataChip>
  );
};

const anchorOrigin: PopoverOrigin = {
  vertical: "bottom",
  horizontal: "right",
};
const transformOrigin: PopoverOrigin = {
  vertical: "top",
  horizontal: "right",
};
